var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _rect2, _path14, _path15, _path16, _path17, _path18, _path19, _circle2, _circle3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealtimeload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f3f3bb53-0d5a-4802-9841-c6fb61a45740",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 933.20497,
    height: 686.19123,
    viewBox: "0 0 933.20497 686.19123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M863.78547,789.90439h-592s-12-142.96741,59-144.592,63,63.36053,152-25.99408,197-84.48075,211-31.6803-27,95.04083,48,82.04382S924.78547,690.802,863.78547,789.90439Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M557.79231,789.93692l-1.99805-.065c4.65967-94.12854,28.92822-154.60718,48.46631-188.76642,21.21387-37.09082,41.65625-52.106,41.86035-52.25348l1.3291,1.21411c-.20117.146-20.40527,15.012-41.44922,51.85168C586.57063,635.93265,562.43489,696.16293,557.79231,789.93692Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M772.05207,790.13125l-1.91992-.45373c23.11914-64.46,77.56152-105.15827,78.10938-105.562l1.34375,1.20263C849.04231,685.71866,795.00715,726.12893,772.05207,790.13125Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.02815,790.01626l-1.98145-.22369A148.36826,148.36826,0,0,0,343.45442,686.37c-14.36573-23.62219-30.75684-36.524-30.9209-36.65173l1.38379-1.17249c.1665.12934,16.811,13.2295,31.33008,37.10468A149.73,149.73,0,0,1,365.02815,790.01626Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M492.80429,553.92421l9.64277,11.17378a6.50754,6.50754,0,0,1-.67426,9.16763l-93.12973,80.36926a6.50754,6.50754,0,0,1-9.16763-.67426l-9.64276-11.17378a6.50753,6.50753,0,0,1,.67426-9.16763L483.63666,553.25A6.50753,6.50753,0,0,1,492.80429,553.92421Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M578.07568,561.666l-6.76349-13.11836a6.50752,6.50752,0,0,1,2.79869-8.756l109.33719-56.37147a6.50752,6.50752,0,0,1,8.756,2.79869l6.7635,13.11836a6.50753,6.50753,0,0,1-2.79869,8.756L586.83167,564.46467A6.50753,6.50753,0,0,1,578.07568,561.666Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M569.089,546.61955c.547-1.64786,1.21132-6.582,2.76282-7.361l48.07755-29.13881a6.499,6.499,0,0,1,8.72492,2.89264l12.11543,24.97311-.00012.00048a6.50634,6.50634,0,0,1-2.89217,8.725L584.79716,567.6655a6.50852,6.50852,0,0,1-8.72576-2.89336L569.45023,551.582a6.44847,6.44847,0,0,1-.504-4.46612C568.98725,546.95,569.03429,546.78407,569.089,546.61955Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 548.31013,
    y: 260.57299,
    width: 2,
    height: 197,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M673.70765,114.90439V360.10576a7.99881,7.99881,0,0,0,14.70754,4.35026,200.18039,200.18039,0,0,1,41.97949-46.14036c.48937-.40109.98666-.7941,1.484-1.17911q7.41162-5.84763,15.37695-10.98128c.34488-.2166.68986-.44121,1.03474-.64969a198.47549,198.47549,0,0,1,106.90885-31.0427h203.40332a8,8,0,0,0,8-8V114.90439a8,8,0,0,0-8-8H681.70765A8,8,0,0,0,673.70765,114.90439Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M951.84527,164.9581H694.08257a4.54688,4.54688,0,0,1,0-9.09375h257.7627a4.54688,4.54688,0,1,1,0,9.09375Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M951.84527,185.505H694.08257a4.54736,4.54736,0,0,1,0-9.09472h257.7627a4.54736,4.54736,0,1,1,0,9.09472Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M951.84527,206.05087H694.08257a4.54688,4.54688,0,0,1,0-9.09375h257.7627a4.54688,4.54688,0,1,1,0,9.09375Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.52984,206.05087h-41.80908a4.50491,4.50491,0,0,1-4.5-4.5V159.74228a4.50491,4.50491,0,0,1,4.5-4.5h41.80908a4.50492,4.50492,0,0,1,4.5,4.5v41.80859A4.50492,4.50492,0,0,1,1046.52984,206.05087Zm-41.80908-49.80859a3.50424,3.50424,0,0,0-3.5,3.5v41.80859a3.50424,3.50424,0,0,0,3.5,3.5h41.80908a3.50424,3.50424,0,0,0,3.5-3.5V159.74228a3.50424,3.50424,0,0,0-3.5-3.5Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.584,191.18857a2.08531,2.08531,0,0,1-1.59375-.73438l-13.13086-15.31543a2.10387,2.10387,0,0,1,3.19482-2.73828l10.43555,12.1709a1.08186,1.08186,0,0,0,.89209.38379,1.09726,1.09726,0,0,0,.8501-.47071l32.00586-45.82519a2.10336,2.10336,0,1,1,3.44921,2.4082l-34.37548,49.22168a2.09168,2.09168,0,0,1-1.6211.89746C1025.65484,191.18759,1025.61919,191.18857,1025.584,191.18857Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 549.31013,
    cy: 260.57299,
    r: 23,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 274.31013,
    y: 403.57299,
    width: 2,
    height: 197,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M407.6314,509.128a8.32726,8.32726,0,0,1-6.772-3.49707,143.18759,143.18759,0,0,0-26.12451-27.374q-.52662-.43066-1.05762-.83985c-3.52149-2.77832-7.21924-5.41894-10.99414-7.85156l-.26318-.166c-.15577-.09961-.31153-.19824-.46778-.293a141.62252,141.62252,0,0,0-76.18506-22.19335H141.89751a8.50982,8.50982,0,0,1-8.5-8.5V334.22958a8.50982,8.50982,0,0,1,8.5-8.5H407.70757a8.50982,8.50982,0,0,1,8.5,8.5v166.376a8.38338,8.38338,0,0,1-5.8789,8.08887A8.71174,8.71174,0,0,1,407.6314,509.128Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M401.09331,368.01083H216.209a3.40283,3.40283,0,1,1,0-6.80566H401.09331a3.40283,3.40283,0,1,1,0,6.80566Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M401.09331,382.74814H216.209a3.40284,3.40284,0,0,1,0-6.80567H401.09331a3.40283,3.40283,0,1,1,0,6.80567Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M401.09331,397.48544H216.209a3.40283,3.40283,0,1,1,0-6.80566H401.09331a3.40283,3.40283,0,1,1,0,6.80566Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.1524,397.48544H149.42583a4.50492,4.50492,0,0,1-4.5-4.5V365.25888a4.50492,4.50492,0,0,1,4.5-4.5H177.1524a4.50492,4.50492,0,0,1,4.5,4.5v27.72656A4.50492,4.50492,0,0,1,177.1524,397.48544Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.12847,386.82528a1.63909,1.63909,0,0,1-1.251-.57714l-9.4165-10.98438a1.65271,1.65271,0,0,1,.17822-2.32715,1.65109,1.65109,0,0,1,2.32764.17871l7.48389,8.7295a.6856.6856,0,0,0,.52539.22656.65021.65021,0,0,0,.50195-.27735l22.95557-32.86914a1.65075,1.65075,0,1,1,2.70654,1.89063l-24.65625,35.30371a1.63982,1.63982,0,0,1-1.272.70313Q163.17023,386.82529,163.12847,386.82528Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.31013,
    cy: 403.57299,
    r: 23,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.55477,
    cy: 345.69926,
    r: 53.51916,
    fill: "#009ddd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M535.51951,791.94925H520.76023a6.50752,6.50752,0,0,1-6.5-6.5V662.43558a6.50753,6.50753,0,0,1,6.5-6.5h14.75928a6.50753,6.50753,0,0,1,6.5,6.5V785.44925A6.50753,6.50753,0,0,1,535.51951,791.94925Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M614.89,725.9705l-12.00639,8.58471a6.50752,6.50752,0,0,1-9.068-1.50686l-71.54832-100.066a6.50752,6.50752,0,0,1,1.50686-9.068l12.00639-8.58471a6.50752,6.50752,0,0,1,9.068,1.50686l71.54833,100.066A6.50752,6.50752,0,0,1,614.89,725.9705Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M576.12639,791.086l-13.21285-6.5781c-3.20836-1.5973-5.01154-4.5183-4.01941-6.5111l34.053-68.39929c.99213-1.9928,4.40975-2.31459,7.61811-.71729l13.21285,6.5781c3.20836,1.5973,5.01154,4.51829,4.01941,6.5111l-34.053,68.39929C582.75236,792.36147,579.33475,792.68326,576.12639,791.086Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#009ddd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M623.11571,635.20023c0,43.63049-41.04131,57.70416-84.67181,57.70416s-73.32819-14.07367-73.32819-57.70416,29.36951-118,73-118S623.11571,591.56973,623.11571,635.20023Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M506.09931,541.49182a6.4485,6.4485,0,0,1,3.79107,2.41414l8.94229,11.74115A6.50851,6.50851,0,0,1,517.6,564.757l-42.1367,38.48516a6.50635,6.50635,0,0,1-9.10878-1.2334l-.00047-.0001-17.11532-21.85191a6.499,6.499,0,0,1,1.23292-9.10888l47.2925-30.39639c1.38122-1.05176,6.10585.51831,7.82651.75058C505.76253,541.42518,505.93226,541.45579,506.09931,541.49182Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M537.08654,399.47811c-6.30877-12.94911-.7172-28.772,9.56721-37.92479,12.42-11.0534,30.95245-10.98894,45.69721-5.12026,16.01216,6.37312,27.91954,19.904,36.48184,34.45008,4.31623,7.33262,7.68705,15.09554,11.26368,22.79857,3.5037,7.546,7.45525,15.08133,13.36318,21.05075a31.44247,31.44247,0,0,0,18.47324,9.23577c6.446.82339,13.39139-.48293,18.31857-4.94789a18.23785,18.23785,0,0,0,3.06095-3.67789c1.04662-1.62911-1.549-3.13508-2.59041-1.51415-3.5899,5.58783-10.19476,7.67909-16.57524,7.34437a28.23733,28.23733,0,0,1-18.56579-8.56153c-5.96086-6.0229-9.81037-13.736-13.31452-21.35331-3.60956-7.84644-7.10106-15.70756-11.5744-23.11578-8.85953-14.6721-21.02-27.90253-37.172-34.45249-15.061-6.10756-33.75543-6.21047-47.03848,4.12484-11.15553,8.67993-17.87718,24.20961-13.92473,38.17332a30.28749,30.28749,0,0,0,1.9393,5.00454c.84545,1.73533,3.43345.21623,2.59041-1.51415Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M538.9201,394.56845l-14.24365-4.70313a5.49949,5.49949,0,1,1,3.44873-10.44433l14.24365,4.70312a5.49951,5.49951,0,1,1-3.44873,10.44434Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M530.82784,472.43963l-.05566-2c3.7207-.10351,7.001-.33691,9.46582-2.13769a6.148,6.148,0,0,0,2.38135-4.52832,3.51437,3.51437,0,0,0-1.15283-2.89453c-1.63623-1.38184-4.269-.93457-6.188-.05469l-1.65479.75879,3.17334-23.19043,1.98145.27148-2.69922,19.72657c2.60742-.7666,5.02344-.43653,6.67822.96093a5.471,5.471,0,0,1,1.86035,4.49219,8.13266,8.13266,0,0,1-3.20019,6.07324C538.2507,472.23163,534.135,472.34686,530.82784,472.43963Z",
    transform: "translate(-133.39751 -106.90439)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 415.18033,
    y: 333.46103,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 381.18033,
    y: 333.46103,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 266.55764,
    y: 683.9505,
    width: 324.03261,
    height: 2.24072,
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtimeload);
export default __webpack_public_path__ + "static/media/realtimeload.37b0600beb0f47bc2a3a3fb9ac8ab6e7.svg";
export { ForwardRef as ReactComponent };